module.exports = __webpack_public_path__ + "static/media/account-image-3.cc4bbef5.jpg";